export default __webpack_public_path__ + "static/media/defaultItem.2aebb012.png";